$(function() {
    // ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'load_post',
            postType: null,
            url: myajax,
            catId: 'all',
            paged: 1,
        };

    // Ajax helper function
    function loadPosts(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                $('.js-ajax-load').css({ 'opacity': '.3', 'pointer-events': 'none' });
            },
            success(data) {
                $('.js-ajax-load').html(data);
            },
            complete() {
                $('.js-ajax-load').css({ 'opacity': '1', 'pointer-events': 'auto' });
            }
        });
    }

    // Filter
    $('body').on('click', '.js-load-post', function H(e) {
        e.preventDefault();
        let $this = $(this),
            postType = $this.data('post-type'),
            catID = $this.data('cat-id');
        if (!$this.hasClass('active')) {
            $('.js-load-post').removeClass('active');
            $this.addClass('active');
        }
        paramObj.catId = catID ? catID : 'all';
        paramObj.postType = postType;
        paramObj.paged = 1;
        loadPosts(paramObj);
    });

    $(document).on('click', '.pi-pagination .page-numbers', function H(e) {
        e.preventDefault();
        let catID = $(this).closest('.pi-pagination').data('cat');
        if (catID) {
            paramObj.catId = catID;
        }
        if($(this).hasClass('next')) {
            paramObj.paged = Number($('.pi-pagination .page-numbers.current').html())+1;
        } else if($(this).hasClass('prev')) {
            paramObj.paged = Number($('.pi-pagination .page-numbers.current').html())-1;
        } else {
            paramObj.paged = $(this).html();
        }
        loadPosts(paramObj);
    });
});